import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-axie-ronin",
  "use": "icon-axie-ronin-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" id=\"icon-axie-ronin\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M1.333 2h13.334C15.403 2 16 2.576 16 3.286v9.428c0 .71-.597 1.286-1.333 1.286H1.333C.597 14 0 13.424 0 12.714V3.286C0 2.576.597 2 1.333 2zm5.334 4.286c0-.946-.798-1.715-1.778-1.715s-1.778.77-1.778 1.715C3.111 7.23 3.908 8 4.89 8c.98 0 1.778-.769 1.778-1.714zM8 10.914c0 .284-.278.514-.622.514H2.4c-.344 0-.622-.23-.622-.514V10.4c0-.852.836-1.543 1.866-1.543h.14a2.97 2.97 0 002.21 0h.14C7.163 8.857 8 9.548 8 10.4v.514zm6-1.2a.219.219 0 00.222-.214v-.429c0-.117-.1-.214-.222-.214h-4a.219.219 0 00-.222.214V9.5c0 .118.1.214.222.214h4zm.222-1.928c0 .118-.1.214-.222.214h-4a.219.219 0 01-.222-.214v-.429c0-.118.1-.214.222-.214h4c.122 0 .222.096.222.214v.429zM14 6.286a.219.219 0 00.222-.215v-.428c0-.118-.1-.214-.222-.214h-4a.219.219 0 00-.222.214v.428c0 .118.1.215.222.215h4z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/axie/axie-ronin.svg
// module id = VdOB
// module chunks = 62